import { PackageEnum } from '@insurance/api/requests'
import { SelectProps } from 'antd'
import { TFunction } from 'i18next'

export const packageList = Object.values(PackageEnum)

export const packageOptions = (t: TFunction): SelectProps['options'] =>
  packageList.map((value) => ({
    label: t(value),
    value
  }))
